export default {
    name: "CustomerLogoManage",
    data() {
        return {
            logoPath: '',
            imagePath: '',
            uploadHeaders: {Authorization: `Bearer ${sessionStorage.getItem('token')}`},
            loadded: false
        }
    },
    created() {
        this.getCompanyInfo();
    },
    methods: {
        uploadError(){
            this.$message({
                message: this.$t('EM-101'),
                type: 'error',
                center: true
            });
        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/png';
            const isLt1M = file.size / 1024 / 1024 < 1;

            if (!isJPG) {
                this.$message({
                    message: this.$t('customerLogo.onlyPng'),
                    type: 'error',
                    center: true
                });
            }else if (!isLt1M) {
                this.$message({
                    message: this.$t('customerLogo.only1m'),
                    type: 'error',
                    center: true
                });
            }
            return isJPG && isLt1M;
        },
        getCompanyInfo() {
            this.$axios.get('/api/customerinfo/selectcustomerbyparam').then(response => {
                if(response.data.resultData[0].billLogo){
                    this.logoPath = '/api' + response.data.resultData[0].billLogo;
                }
                if(response.data.resultData[0].billImage){
                    this.imagePath = '/api' + response.data.resultData[0].billImage;
                }
                this.loadded = true
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        edit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.form);
                    this.$axios.put('/api/accounts/modifyPassword', {params: param}).then(response => {
                        if (response.data.status === '1') {
                            this.$message({
                                message: this.$t('userManage.message.passwordModifySucceed'),
                                type: 'success',
                                center: true
                            });
                        } else {
                            this.$message({
                                message: this.$t('userManage.message.passwordModifyFailed'),
                                type: 'error',
                                center: true
                            });
                        }
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('userManage.message.passwordModifyFailed'),
                            type: 'error',
                            center: true
                        });
                    });
                }
            });
        }
    }
}
